// src/mobile_pages/system/User_company_add.jsx
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { createCompany, createFactory } from "../../api/users/companies";
import { getProjectDetail } from "../../api/project";
import MobileCompanyForm from "../../components/company/MobileCompanyForm";
import { Building2 } from "lucide-react";

const EMPTY_COMPANY = {
  name: "",
  registration_no: "",
  address: "",
  detail_address: "",
  extra_address: "",
  phone: "",
  email: "",
};

const EMPTY_FACTORY_ROW = {
  name: "",
  address: "",
  detail_address: "",
  extra_address: "",
};

const User_company_add = () => {
  const navigate = useNavigate();
  const projectId = localStorage.getItem("projectId");

  const [projectPeriod, setProjectPeriod] = useState({
    start_date: "",
    end_date: "",
  });

  const [newCompany, setNewCompany] = useState({ ...EMPTY_COMPANY });
  const [hasFactories, setHasFactories] = useState(false);
  const [factoryRows, setFactoryRows] = useState([{ ...EMPTY_FACTORY_ROW }]);

  useEffect(() => {
    const fetchProject = async () => {
      try {
        const res = await getProjectDetail(projectId);
        const data = res?.data ?? res;
        setProjectPeriod({
          start_date: data.start_date,
          end_date: data.end_date,
        });
      } catch (err) {
        console.error("프로젝트 정보 불러오기 실패:", err);
      }
    };
    if (projectId) fetchProject();
  }, [projectId]);

  const handleCreateCompany = async (payload) => {
    try {
      const res = await createCompany(payload.company);
      const created = res?.data ?? res;
      const companyId = created?.id;

      if (payload.factories.length > 0 && companyId) {
        await Promise.all(
          payload.factories.map((r) =>
            createFactory({ company: companyId, ...r })
          )
        );
      }

      const mp = created?._membership_prompt;
      if (mp?.should_prompt && mp.user_id && mp.company_id) {
        if (
          window.confirm(
            "현재 소속된 회사가 없습니다.\n지금 등록한 회사를 내 소속 회사로 연결할까요?"
          )
        ) {
          alert("내 소속 회사로 연결되었습니다.");
        }
      }

      setNewCompany({ ...EMPTY_COMPANY });
      setHasFactories(false);
      setFactoryRows([{ ...EMPTY_FACTORY_ROW }]);

      alert("회사 등록이 완료되었습니다.");
      navigate(`/project/${projectId}/system/user/company`);
    } catch (error) {
      console.error("회사 등록 실패:", error?.response?.data || error);
      alert("등록 실패\n" + JSON.stringify(error?.response?.data || {}, null, 2));
    }
  };

  return (
    <div className="mobile-page-root">
      <div className="mobile-page-root-inner space-y-4 mobile-bottom-spacing pb-24">
        {/* Header */}
        <div className="mobile-page-header">
          <div className="flex items-center gap-2">
            <Building2 className="w-5 h-5 text-blue-600" />
            <h1 className="mobile-page-title">회사 등록</h1>
          </div>
        </div>

        {/* Mobile Company Form */}
        <MobileCompanyForm
          newCompany={newCompany}
          setNewCompany={setNewCompany}
          hasFactories={hasFactories}
          setHasFactories={setHasFactories}
          factoryRows={factoryRows}
          setFactoryRows={setFactoryRows}
          onCreate={handleCreateCompany}
          projectPeriod={projectPeriod}
          EMPTY_COMPANY={EMPTY_COMPANY}
          EMPTY_FACTORY_ROW={EMPTY_FACTORY_ROW}
        />
      </div>
    </div>
  );
};

export default User_company_add;
